module.exports = __webpack_public_path__ + "present.svg?fccc44f24a49f09dbf2680123e7e4f31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/present.svg
// module id = 129
// module chunks = 0